module.exports = __webpack_public_path__ + "assets/img/btn-more-4bbf9a8b.png";